


jQuery(document).ready( function(){

  const $ = jQuery;

	/*
 _   _     _               
| | | |   | |              
| | | |___| |__   ___ _ __ 
| | | / __| '_ \ / _ \ '__|
| |_| \__ \ | | |  __/ |   
 \___/|___/_| |_|\___|_|

	*/
	// Check if bb_usher cookie does not exist and show popup if not
	if (document.cookie.indexOf("bb_usher") === -1) {
		let bb_usher = $('#bb_usher');
		if (bb_usher){
			bb_usher.css('display','flex');
			// handle close click
			bb_usher.find(".close-usher").on('click', function(){
				// Set bb_usher cookie for one year
				document.cookie = "bb_usher" + "=" + "1" + ";expires=" + new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 365)).toUTCString();
				bb_usher.hide();
			});
		}
	}


  /*
 _                         _____          _ _       _               
| |                       /  ___|        (_) |     | |              
| |     __ _ _ __   __ _  \ `--.__      ___| |_ ___| |__   ___ _ __ 
| |    / _` | '_ \ / _` |  `--. \ \ /\ / / | __/ __| '_ \ / _ \ '__|
| |___| (_| | | | | (_| | /\__/ /\ V  V /| | || (__| | | |  __/ |   
\_____/\__,_|_| |_|\__, | \____/  \_/\_/ |_|\__\___|_| |_|\___|_|   
                    __/ |                                           
                   |___/
  */
  let bb_lang = $('.bb_lang_switcher');
  if (bb_lang){
    bb_lang.on('click', function() {
      bb_lang.find('.lang_menu').toggleClass('open');
    });
  }

  /*
 _____                           _   _             
/  __ \                         | | (_)            
| /  \/ ___  _ __   ___ ___ _ __| |_ _ _ __   __ _ 
| |    / _ \| '_ \ / __/ _ \ '__| __| | '_ \ / _` |
| \__/\ (_) | | | | (_|  __/ |  | |_| | | | | (_| |
 \____/\___/|_| |_|\___\___|_|   \__|_|_| |_|\__,_|

  */
  $('.accordion').each( function(){
    let parent = $(this);

    // Handle splitting into 2 cols if needed
    if ( parent.hasClass('concertina-2col') ){
      let list1 = [];
      let list2 = [];
      parent.find('.accordion-item').map( function(i,item){
        if (i % 2 == 0){
          list1.push(item);
        } else {
          list2.push(item);
        }
      });
      
      // replace contents of accordion with these two new cols
      parent.html("<div class='concertina-col'>" + list1.map((item) => item.outerHTML).join('') + "</div>" + "<div class='concertina-col'>" + list2.map((item) => item.outerHTML).join('') + "</div>");
    }

    // Handle clicks
    parent.find('.accordion-item').on('click', function(){
      $(this).find('.accordion-header').toggleClass("open");
      $(this).find('.accordion-collapse').toggleClass("collapse");
    });

  });


/*
 _   _       _                   _   
| | | |     | |                 | |  
| |_| | ___ | |_ ___ _ __   ___ | |_ 
|  _  |/ _ \| __/ __| '_ \ / _ \| __|
| | | | (_) | |_\__ \ |_) | (_) | |_ 
\_| |_/\___/ \__|___/ .__/ \___/ \__|
                    | |              
                    |_|
*/
  const hideDot = null;
  const hideHotspot = function(dot){
      dot.attr('data-open','0');
      dot.parent().parent().find('.hotspotModal').hide();
  }
  const showHotspot = function(dot){
      dot.attr('data-open','1');
      dot.parent().find('.hotspotModal .hotspotModalText').text( dot.attr('data-text') );
      dot.parent().find('.hotspotModal').css('left', 'calc(' + dot.attr('data-x') + "% + 40px)").css('top', dot.attr('data-y') + "%").fadeIn("fast");
  }

  $('.hotspotContainer').each( function(){
    // create modal div
    $(this).find('.hotspotImageContainer').prepend('<div class="hotspotModal"><div class="hotspotModalClose"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z" fill="#ffffff"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z" fill="#ffffff"></path> </g></svg></div><div class="hotspotModalText">Text in here</div></div>');
    $(this).find('.hotspotModalClose').on('click', function(){
      hideHotspot($(this));
    });
    $(this).find('.hotspotDot').on('click', function(){
      if ( $(this).attr('data-open') === "1" ){
        hideHotspot($(this));
      } else {
        showHotspot($(this));
      }
    });
    $(this).find('.hotspotDot').on('mouseenter', function(){
      showHotspot($(this));
    });
    $(this).find('.hotspotDot').on('mouseleave', function(){
        hideHotspot($(this));
    });
  });

});
